import axiosInterceptors from "../axiosInterceptor/axiosInterceptor";
import {  dashboardUrl } from "../config/apiConfig";

export const getDashBoardPageData = () => {
  return axiosInterceptors()
    .get(dashboardUrl + "/getDashBoardPageData")
    .then((res) => res);
};
